const rarity_options = [
  { key: 'all', value: '< 全部 >'},
  { key: 'r5', value: '5'},
  { key: 'r4', value: '4'},
  { key: 'r3', value: '3'},
  { key: 'r2', value: '2'},
]

const exclusive_options = [
  { key: 'all', value: '< 全部 >'},
  { key: 'c_weapon', value: '[ 武器限定 ]'},
  { key: 'sword', value: '劍'},
  { key: 'blade', value: '刀'},
  { key: 'dagger', value: '短劍'},
  { key: 'axe', value: '斧'},
  { key: 'lance', value: '槍'},
  { key: 'bow', value: '弓'},
  { key: 'wand', value: '魔杖'},
  { key: 'staff', value: '法杖'},
  { key: 'c_element', value: '[ 屬性限定 ]'},
  { key: 'flame', value: '火'},
  { key: 'water', value: '水'},
  { key: 'wind', value: '風'},
  { key: 'light', value: '光'},
  { key: 'shadow', value: '闇'}
]

const condition_options = [
  { key: 'all', value: '< 全部 >'},
  { key: 'hfl', value: 'HP全滿'},
  { key: 'h70', value: 'HP70%'},
  { key: 'lst', value: '背水之陣'},
  { key: 'dbb', value: '守護之鏈'},
  { key: 'flr', value: '疾風怒濤'},
  { key: 'hts', value: '連擊'},
  // { key: 'drg_clw', value: '龍族恩寵'},
  { key: 'stk', value: '強擊'},
  { key: 'stkr', value: '爆發擊破'},
  { key: 'slyr', value: '獅子奮迅'},
  { key: 'unt', value: '團結一致'},
  { key: 'rsl', value: '起死回生'}
]

const effect_options = [
  { key: 'all', value: '< 全部 >'},

  { key: 'c_atk', value: '[ 攻擊類 ]'},
  { key: 'skl_dmg', value: '技能傷害'},
  { key: 'str', value: '攻擊力'},
  { key: 'crt_rt', value: '爆擊率'},
  { key: 'crt_dmg', value: '爆擊傷害'},
  { key: 'frc_stk', value: '爆發傷害'},
  { key: 'enr', value: '活力'},

  { key: 'c_pns', value: '[ 特攻類 ]'},
  { key: 'ovd_pns', value: 'Overdrive特攻'},
  { key: 'brk_pns', value: 'BREAK特攻'},
  { key: 'psn_pns', value: '毒特攻'},
  { key: 'brn_pns', value: '火燒特攻'},
  { key: 'frz_pns', value: '凍結特攻'},
  { key: 'prl_pns', value: '麻痺特攻'},
  { key: 'bln_pns', value: '黑暗特攻'},
  { key: 'stn_pns', value: '昏厥特攻'},
  { key: 'crs_pns', value: '詛咒特攻'},
  { key: 'bg_pns', value: '濕身特攻'},
  { key: 'slp_pns', value: '睡眠特攻'},

  { key: 'c_sp', value: '[ 特殊類 ]'},
  { key: 'skl_prp', value: '開場技能量條'},
  { key: 'skl_chr', value: '技能蓄集'},
  { key: 'skl_hst', value: '技能累積'},
  { key: 'bf_tm', value: '增益效果時間'},
  { key: 'gg_acl', value: 'Overdrive削減'},
  { key: 'gg_inh', value: 'Overdrive抑制'},

  { key: 'c_drg', value: '[ 龍化類 ]'},
  { key: 'shs_prp', value: '開場龍化量條'},
  { key: 'drg_dmg', value: '龍化中傷害提升'},
  { key: 'drg_tm', value: '龍化時間'},
  { key: 'drg_clw', value: '龍族恩寵・攻'},

  { key: 'c_dfn', value: '[ 防禦類 ]'},
  { key: 'hp', value: 'HP'},
  { key: 'dfn', value: '防禦力'},
  { key: 'shl_prp', value: '開場傷害・盾'},

  { key: 'c_dbf_rs', value: '[ 異常狀態抗性類 ]'},
  { key: 'afl_grd', value: '異常狀態無效'},
  { key: 'psn_rs', value: '毒抗性'},
  { key: 'brn_rs', value: '火燒抗性'},
  { key: 'frz_rs', value: '凍結抗性'},
  { key: 'prl_rs', value: '麻痺抗性'},
  { key: 'bln_rs', value: '黑暗抗性'},
  { key: 'stn_rs', value: '昏厥抗性'},
  { key: 'crs_rs', value: '詛咒抗性'},
  { key: 'bg_rs', value: '濕身抗性'},
  { key: 'slp_rs', value: '睡眠抗性'},

  { key: 'c_el_rs', value: '[ 屬性抗性類 ]'},
  { key: 'flm_rs', value: '火屬性抗性'},
  { key: 'wtr_rs', value: '水屬性抗性'},
  { key: 'wnd_rs', value: '風屬性抗性'},
  { key: 'lgh_rs', value: '光屬性抗性'},
  { key: 'shd_rs', value: '闇屬性抗性'},

  { key: 'c_rc_rs', value: '[ 種族抗性類 ]'},
  { key: 'hmd_rs', value: '真・碧龍抗性'},
  { key: 'hbr_rs', value: '真・緋龍抗性'},
  { key: 'hmr_rs', value: '真・青龍抗性'},
  { key: 'hjp_rs', value: '真・輝龍抗性'},
  { key: 'hzd_rs', value: '真・闇龍抗性'},
  { key: 'md_rs', value: '碧龍抗性'},
  { key: 'br_rs', value: '緋龍抗性'},
  { key: 'mr_rs', value: '青龍抗性'},
  { key: 'jp_rs', value: '輝龍抗性'},
  { key: 'zd_rs', value: '闇龍抗性'},

  { key: 'c_hl', value: '[ 回復類 ]'},
  { key: 'rcv_ptn', value: '回復技能效果'},
  { key: 'hl', value: '治癒'},

  { key: 'c_other', value: '[ 其他 ]'},
  { key: 'exp', value: '玩家經驗值提升'}
]

const type_options = [
  { key: 'all', value: '< 全部 >'},
  { key: 'common', value: '常駐'},
  { key: 'seasonal', value: '限定'},
  { key: 'event', value: '活動'},
  { key: 'collab', value: '合作'},
  { key: 'promo', value: '特典'}
]

const Options = {
  rarity    : rarity_options,
  exclusive : exclusive_options,
  condition : condition_options,
  effect    : effect_options,
  type      : type_options
}

export default Options